export const AfterFirstDigitRegex = /\d.*$/g;
export const BeforeDigitRegex = /^\D+/g;
